import { Card } from '@/components/shadcn/card';
import { Separator } from '@/components/shadcn/separator';
import type { BadmintonTopMmrItem } from '@/services/badmintonService';
import { formatDeltaMmr, formatTopMmrSubtitle } from './badmintonUiUtils';

interface BadmintonTopMmrListProps {
  items: BadmintonTopMmrItem[];
}

function rankClass(position: number): string {
  return position <= 3 ? 'text-[#FC480D]' : 'text-gray-400';
}

export default function BadmintonTopMmrList({ items }: BadmintonTopMmrListProps) {
  if (items.length === 0) {
    return (
      <Card className="rounded-2xl border-0 bg-white px-4 py-8 text-center text-sm text-gray-400 shadow-[inset_0_0_0_1px_#E0E6ED]">
        Belum ada data Top MMR
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden rounded-2xl border-0 bg-white shadow-[inset_0_0_0_1px_#E0E6ED]">
      {items.map((item, index) => (
        <div key={item.participantId}>
          {index > 0 && <Separator className="bg-gray-50" />}
          <div className="flex items-center gap-3 px-4 py-3">
            <span className={`w-6 text-sm font-extrabold ${rankClass(item.position)}`}>
              {item.position}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-extrabold text-[#0E1726]">{item.playerName}</p>
              <p className="text-xs text-gray-400">
                {formatTopMmrSubtitle(item.wins, item.losses, item.setsWon, item.setsLost)}
              </p>
            </div>
            <p
              className={`text-sm font-extrabold ${
                item.deltaMmr >= 0 ? 'text-emerald-500' : 'text-red-500'
              }`}
            >
              {formatDeltaMmr(item.deltaMmr)} MMR
            </p>
          </div>
        </div>
      ))}
    </Card>
  );
}
